export const keyMapsAction = {
  // dispatch
  ANONYMOUS_USER_API: "Auth/anonymousUserApi",
  LOAD_LOGIN_STATUS: "Auth/loadLoginStatus",
  PAYMENT_PAGE_COMMON_ACTION: "Payments/paymentPageCommonAction",
  OTHER_PAYMENT_OPTION_API: "Payments/getOtherPaymentApi",
  PAYTM_WALLET_BALANCE_API: "Payments/getPaytmWalletBalance",
  GET_SELECTED_ADDRESS_OBJECT: "Address/getSelectedAddress",
  GET_CART_DATA: "PriceDetail/getCartData",
  GET_INIT_CART_SPECIFIC_FOR_PAYMENT:
    "PriceDetail/getInitCartSpecificForPayment",
  POST_SUBMIT_ORDER: "PaymentSubmit/postSubmitOrder",
  PROCEED_TO_PAYMENT_API: "PaymentSubmit/proceedToPaymentAPI",
  TRIGGER_SUBMIT_PAYTM_WALLET_REDEEM:
    "PaytmWallet/triggerSubmitPaytmWalletRedeem",
  TOGGLE_REDEEM_PAYTM_WALLET_MODAL_ACTION:
    "PaytmWallet/toggleRedeemPaytmWalletModal",
  SUBMIT_PAYTM_WALLET_REDEEM: "PaytmWallet/submitPaytmWalletRedeem",
  //updatePaymentModeTemp
  SET_PAYMENT_MODE_TEMP_ACTION: "PaymentSubmit/setPaymentModeTemp",
  SET_PAYMENT_MODE_ACTION: "PaymentSubmit/setPaymentMode",
  SET_PAYMENT_MODE_INIT_ACTION: "PaymentSubmit/setPaymentModeInit",
  GET_CHARGE_STATUS_ACTION: "PaymentSubmit/getChargeStatus",
  GET_PROCESS_TRANSACTION_API_ACTION: "PaymentSubmit/getProcessTransactionApi",
  TOGGLE_PAYTM_LINK_MODAL_ACTION: "PaytmWallet/togglePaytmWalletModal",
  UPI_WALLET_PAYMENT_GATEWAY_ACTION: "Upi/upiWalletPaymentGateway",
  UPI_COLLECT_FLOW_POLLING: "Upi/collectFlowPolling",
  UPDATE_CONTENT_ACTION: "ErrorModal/updateContent",
  OPEN_ERROR_MODAL: "PaymentSubmit/openErrorModalFun",
  TOGGLE_ALL_WALLET_MODAL: "Wallet/toggleAllWalletModal",
  INIT_PLACE_ORDER: "PaymentSubmit/initPlaceOrder",
  PAYMENT_SUBMIT_ORDER: "PaymentSubmit/paymentSubmitOrder",
  GIFTCARD_VALIDATION_HANDLER: "GiftCardAndEvoucher/giftCardValidationHandler",
  APPLY_PROMO: "PriceDetail/applyPromo",
  BIN_OFFER_SAVE_PAYMENT_API: "Payments/binOfferSavePaymentApi",
  CHECK_RADIO_ID_FOR_PROMO: "PaymentSubmit/checkRadioIdForPromo",
  REMOVE_PROMO: "PriceDetail/removePromo",
  GET_COD_OTP: "Cash/getCodOtp",
  ADD_UPI_ID_API: "Upi/addUpiIdApi",
  RESEND_GIFT_CARD_OTP_API: "GiftCardAndEvoucher/resendGiftCardOtpApi",
  RESEND_OTP: "CreditDebit/resendOTP",
  RESEND_UNIFIED_OTP: "CreditDebit/resendOTPHandler",
  CARD_CHECK_VALIDATOR: "CreditDebit/cardCheckValidator",
  SUBMIT_OTP: "CreditDebit/submitOTP",
  SUBMIT_UNIFIED_OTP: "CreditDebit/submitOTPHandler",
  UPDATE_RESEND_OTP_TIME_HANDLER: "CreditDebit/resendOtpTimerHandler",
  CLEAR_RESEND_OTP_TIMER: "CreditDebit/clearResendOtpTimer",
  TOGGLE_ENTER_CARD_OTP_MODAL: "CreditDebit/otpTimerWithModal",
  TOGGLE_HTML_PAYMENT_MODAL: "PaymentSubmit/toggleHtmlPaymentModal",
  AMPLITUDE_PAYMENT_STATUS: "Global/amplitudePaymentStatus",
};

export const keyMapsMutation = {
  // Commit
  UPDATE_LOGGIN_STATE: "Auth/updateLogginState",
  UPDATE_UTM_SOURCE: "Auth/updateUTMSource",
  UPDATE_AUTH_SOURCE: "Auth/updateSource",
  UPDATE_VIEWALL_MODAL_FLAG: "Payments/updateViewallModalFlag",

  UPDATE_PWA_CONFIG: "Global/updatePwaConfig",
  UPDATE_APP_CONFIG: "Global/updateAppConfig",
  UPDATE_DISPALY_PRICE: "Global/updateDisplayPrice",

  UPDATE_SHOW_LINK_PAYTM_WALLET: "PaytmWallet/updateShowLinkWallet",
  UPDATE_PAYTM_WALLET_RESPONSE: "PaytmWallet/updatePaytmWalletResponse",
  UPDATE_PAYMENT_MODE: "PaymentSubmit/updatePaymentMode",
  UPDATE_PAYMENT_MODE_TEMP: "PaymentSubmit/updatePaymentModeTemp",
  UPDATE_IS_PLACE_ORDER_ACTIVE: "PaymentSubmit/updateIsPlaceOrderActive",
  UPDATE_UPI_INTENT_CONFIG_MUTATION: "PaymentSubmit/updateUpiIntentConfig",
  UPDATE_PAYLOAD_FOR_PAYTM_PG_MUTATION:
    "PaymentSubmit/updatePayloadForPaytm_pg",
  UPDATE_IS_PAYTM_WALLET_OTP_SCREEN: "PaytmWallet/updateIsOtpScreenEnable",
  UPDATE_ERROR_MODAL_OPEN_MUTATION: "ErrorModal/updateErrorModalOpen",
  UPDATE_CMS_OTHER_PAYMENTS_DATA: "Payments/updateCmsOtherPaymentsData",
  UPDATE_EVOUCHER_OTP: "GiftCardAndEvoucher/updateEvoucherOtp",
  UPDATE_EVOUCHER_SCREEN: "GiftCardAndEvoucher/updateEvoucherScreen",
  UPDATE_EVOUCHER_NUMBER: "GiftCardAndEvoucher/updateEvoucherNumber",
  UPDATE_EVOUCHER_IS_DISABLE_KEY:
    "GiftCardAndEvoucher/updateEvoucherIsDisableKey",
  UPDATE_EVOUCHER_MODAL_OPEN: "GiftCardAndEvoucher/updateEvoucheModalOpen",
  UPDATE_EVOUCHER_ERRORMSG: "GiftCardAndEvoucher/updateEvoucherErrorMsg",
  UPDATE_SELECTED_BANK_CVV_DATA: "PaymentSubmit/updateSelectedBankCvvData",
  UPDATE_SCROLL_ID_FOR_PAYMENT: "PaymentSubmit/updateScrollIdForPayment",
  UPDATE_SAVE_CARD_BANK_MODAL: "Payments/updateSaveCardBankModal",
  UPDATE_SAVED_CARD_CVV: "CreditDebit/updateSavedCardCvv",
  UPDATE_MAIN_SCREEN_FOR_SAVED_PAYMENT:
    "Payments/updateMainScreenForSavedPayment",
  UDPATE_IS_REMOVE_PROMO: "ErrorModal/updateIsRemovePromo",
  UPDATE_ADD_PROMO_CODE: "ErrorModal/updateAddPromoCode",
  UPDATE_REMOVE_PROMO_CODE: "ErrorModal/updateRemovePromoCode",
  UPDATE_IS_APPLY_PROMO_BUTTON_ACTIVE:
    "ErrorModal/udpateIsApplyPromoButtonActive",
  UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL: "Payments/updateAddCreditDebitCardModal",
  UDPATE_BIN_TEXT: "PaymentSubmit/updateBinText",
  UPDATE_PAY_USING_OTHER_PAYMENT_MODE:
    "CreditDebit/updatePayUsingOtherPaymentMode",
  UPDATE_RECOMMENDED_VISIBLE_ITEMS: "Payments/updateRecommendedVisibleItems",
  UPDATE_CASH_PROCESS_TOGGLE: "Cash/updateCashProcessToggle",
  UPDATE_SAVE_CARD_CVV_MODAL: "CreditDebit/updateSaveCardCvvModal",
  UPDATE_WALLET_LINK_MODAL: "PaytmWallet/updateWalletLinkModal",
  UPDATE_ADD_UPI_ID_MODAL: "Upi/updateAddUpiIdModal",
  UPDATE_ENTERED_UPI_ID: "Upi/updateEnteredUPiId",
  UPDATE_MAIN_SCREEN_FOR_NB: "Payments/updateMainScreenForNB",
  UPDATE_NB_PLACE_ORDER_BUTTON_COLOR_GRAY:
    "NetBanking/updatePlaceOrderButtonColorGray",
  UPDATE_NET_BANKING_MODAL: "NetBanking/updateNetBankingModal",
  UPDATE_CC_PLACE_ORDER_BUTTON_COLOR_GRAY:
    "CreditDebit/updatePlaceOrderButtonColorGray",
  UPDATE_CUSTOM_CONTINUE_PROGRESS_BAR:
    "CreditDebit/updateCustomContinueProgressBar",
  UPDATE_IS_OTP_SCREEN_ENABLE: "CreditDebit/updateIsOtpScreenEnable",
  UPDATE_DISABLE_RESEND_KEY: "CreditDebit/updateDisableResendKey",
  UPDATE_CREDIT_AND_DEBIT_CARD_NUMBER:
    "CreditDebit/updateCreditAndDebitCardNumber",
  UPDATE_MAIN_SCREEN_FOR_WALLET: "Payments/updateMainScreenForWallet",
  UPDATE_CURRENT_PAYMENT_OBJECT: "Payments/updateCurrentPaymentObject",
  UPDATE_CIRCLE_RELOAD_MODAL: "Upi/updateCircleReloadModal",
  UPI_COLLECT_FLOW_LOADER: "Upi/updatePayViaUpiCollectModalBarModal",
  UPDATE_ALL_NET_BANKING_BANK: "NetBanking/updateAllNetBankingBanks",
  UPDATE_CASH_OTP_TOGGLE: "Cash/updateCashOtpToggle",
};

export const keyMapsGetter = {
  //
};
